export default {
  CHAT_POPUP: "ChatPopup",
  CONFIRM_POPUP: "ConfirmPopup",
};
